import React from "react";
import Nav from "../Nav"
import Footer from "../Footer"
import PendingBody from "../PendingBody";
export default function PendingPage(){
    
    return(

        <div>
              <Nav/>
            <PendingBody/>
            <Footer/>


        </div>

    );


}